import React, {FunctionComponent} from 'react';

import YearFilters from '../filters/year-filters/year-filters';
import CategoriesFilters from '../filters/categories-filters/categories-filters';
import TagsFilters from '../filters/tags-filters/tags-filters';

import styles from './filter-group.module.css';

export type filterGroupCategoryType = 'year' | 'categories' | 'tags';

interface Props {
  title: string;
  filterGroupCategory: filterGroupCategoryType;
}

const FilterGroup: FunctionComponent<Props> = props => {
  const {filterGroupCategory, title} = props;

  const COMPONENTS = {
    year: YearFilters,
    categories: CategoriesFilters,
    tags: TagsFilters
  };

  const FilterGroupComponent = COMPONENTS[filterGroupCategory];

  return (
    <section className={styles.filterGroup}>
      <h5 className={styles.filterGroupTitle}>{title}</h5>
      <FilterGroupComponent />
    </section>
  );
};
export default FilterGroup;
